var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pages.length > 1
    ? _c("div", { staticClass: "tabs" }, [
        _c(
          "ul",
          _vm._l(_vm.pages, function (page) {
            return _c(
              "li",
              { key: page.id },
              [
                _c(
                  "router-link",
                  {
                    class: "gtm-" + page.link.params.page + "-tab",
                    attrs: { to: page.link },
                  },
                  [_vm._v(_vm._s(page.name))]
                ),
              ],
              1
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }